/**
 * @file: DetectResult.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食品检测管理
 */
import request from '@/utils/request'

/**
 * 大屏-第一食堂-食品快检记录分页列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectPcResultListGet(data) {
  return request({
    type: 'biz',
    url: 'detect/pc/result/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据IDs批量删除检测记录信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectResultBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'detect/result/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 根据ID获取记录信息详情(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectResultDetailGet(data) {
  return request({
    type: 'biz',
    url: 'detect/result/detail/get',
    method: 'post',
    data
  })
}

/**
 * 根据条件获取检测记录分页列表信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectResultListGet(data) {
  return request({
    type: 'biz',
    url: 'detect/result/list/get',
    method: 'post',
    data
  })
}

/**
 * 检测记录信息复核(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectResultReviewUpdate(data) {
  return request({
    type: 'biz',
    url: 'detect/result/review/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DetectResult.js